const fontFamily = {
  default: 'Open Sans',
  fallback: 'Arial',
  fallbackIos: '-apple-system',
  fallbackAndroid: 'Roboto',
  appleEmoji: 'Apple Color Emoji',
  windowsEmoji: 'Segoe UI Emoji',
  windowsSymbol: 'Segoe UI Symbol',
  icons: 'Icons'
};

const fontSize = {
  base: '62.5%',
  big: '1.8rem',
  medium: '1.6rem',
  normal: '1.4rem',
  small: '1.2rem'
};

const fontWeight = {
  light: 300,
  regular: 400,
  semibold: 600,
  bold: 700,
  extrabold: 800
};

const lineHeight = {
  base: 1.5
};

export const typography = {
  fontFamily,
  fontSize,
  lineHeight,
  fontWeight
};
